module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.gotData) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('span', {
    staticClass: "carViewTitle"
  }, [_vm._v(" " + _vm._s(_vm.ItemsDetails[0].title) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('span', {
    staticClass: "carViewOfferPrice"
  }, [_vm._v("Ahora: " + _vm._s(_vm.ItemsDetails[0].currency_name) + "$" + _vm._s(_vm._f("AddCommasToNumber")(_vm.ItemsDetails[0].offerprice)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "carViewPrice"
  }, [_vm._v("Antes: " + _vm._s(_vm.ItemsDetails[0].currency_name) + "$"), _c('strike', [_vm._v(_vm._s(_vm._f("AddCommasToNumber")(_vm.ItemsDetails[0].price)))])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('span', {
    staticClass: "carPath"
  }, [_vm._v("  " + _vm._s(_vm.ItemsDetails[0].typevehicle_name) + " / " + _vm._s(_vm.ItemsDetails[0].car_brand_name) + " / " + _vm._s(_vm.ItemsDetails[0].car_model_name) + " ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('Gallery', {
    attrs: {
      "id": _vm.ItemsDetails[0].id
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row infoMargin"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('span', {
    staticClass: "boldClass datosGenerales"
  }, [_vm._v("Información del vehículo")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row detalles"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-5"
  }, [_c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Marca:")]), _vm._v("     " + _vm._s(_vm.ItemsDetails[0].car_brand_name) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Modelo:")]), _vm._v("    " + _vm._s(_vm.ItemsDetails[0].car_model_name) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Año:")]), _vm._v("       " + _vm._s(_vm.ItemsDetails[0].model_year) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Pasajeros:")]), _vm._v(" " + _vm._s(_vm.ItemsDetails[0].passengers) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Cilindros:")]), _vm._v(" " + _vm._s(_vm.ItemsDetails[0].enginecylinders) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Tipo:")]), _vm._v("      " + _vm._s(_vm.ItemsDetails[0].typevehicle_name) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Puertas:")]), _vm._v("   " + _vm._s(_vm.ItemsDetails[0].doors) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Traccion:")]), _vm._v("  " + _vm._s(_vm.ItemsDetails[0].tractiontype_name) + "  ")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-7"
  }, [_c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Precio oferta:")]), _vm._v("  " + _vm._s(_vm.ItemsDetails[0].currency_name) + "$" + _vm._s(_vm._f("AddCommasToNumber")(_vm.ItemsDetails[0].offerprice)) + " ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Precio regular:")]), _vm._v(" " + _vm._s(_vm.ItemsDetails[0].currency_name) + "$"), _c('strike', [_vm._v(_vm._s(_vm._f("AddCommasToNumber")(_vm.ItemsDetails[0].price)))])], 1), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Kilometraje:")]), _vm._v("    " + _vm._s(_vm._f("AddCommasToNumber")(_vm.ItemsDetails[0].odometer)) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Color Exterior:")]), _vm._v(" " + _vm._s(_vm.ItemsDetails[0].exteriorcolor_name) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Color Interior:")]), _vm._v(" " + _vm._s(_vm.ItemsDetails[0].interiorcolor_name) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Motor CC:")]), _vm._v("       " + _vm._s(_vm.ItemsDetails[0].enginecc) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Combustible:")]), _vm._v("    " + _vm._s(_vm.ItemsDetails[0].fueltype_name) + "  ")]), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "boldClass"
  }, [_vm._v("Transmission:")]), _vm._v("   " + _vm._s(_vm.ItemsDetails[0].transmissiontype_name) + "  ")]), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('span', {
    staticClass: "descripcion"
  }, [_vm._v(_vm._s(_vm.ItemsDetails[0].description))]), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('InquiryCalculator', {
    attrs: {
      "ItemsDetail": _vm.ItemsDetails[0]
    }
  }), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('hr')]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30410460", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30410460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CarForSaleView.vue
// module id = 111
// module chunks = 0